import { useEffect, useRef } from "react";

// Autoguardado silencioso. Guarda al cambiar el contenido (debounce `delay`)
// y además de forma periódica (`interval`) aunque no se escriba, para no perder nada.
// `fn` debe ser idempotente (que evite reenviar si no hay cambios).
export function useAutosave(watch, fn, { delay = 800, interval = 1500, enabled = true } = {}) {
  const first = useRef(true);
  const fnRef = useRef(fn);
  fnRef.current = fn;

  // Guardado al cambiar el contenido (con pequeño debounce).
  useEffect(() => {
    if (first.current) { first.current = false; return; }
    if (!enabled) return;
    const t = setTimeout(() => fnRef.current(), delay);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watch, enabled]);

  // Guardado periódico continuo (escriban o no).
  useEffect(() => {
    if (!enabled || !interval) return;
    const id = setInterval(() => fnRef.current(), interval);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, interval]);
}
